import React from "react";
import { comboHint } from "../shortcuts/registry.js";

/** Desktop "Table | Cards" switch for list pages (see useListView). */
export function ViewToggle({ view, onChange }) {
  return (
    <div className="view-toggle desktop-only" role="group" aria-label="View" title={`Switch view (${comboHint("list_toggle_view")})`}>
      <button type="button" className={view === "table" ? "active" : ""} aria-pressed={view === "table"} onClick={() => onChange("table")}>
        ☰ Table
      </button>
      <button type="button" className={view === "cards" ? "active" : ""} aria-pressed={view === "cards"} onClick={() => onChange("cards")}>
        ▦ Cards
      </button>
    </div>
  );
}

/**
 * Desktop sticky footer for list pages: "Showing N of M", summary chips, back to top.
 * chips: [{ label, value, tone?: "warning" | "danger" | "success" }]
 */
export function StickyFooter({ shown, total, noun, chips = [] }) {
  return (
    <div className="list-footer desktop-only">
      <span className="list-footer-count">
        Showing <strong>{shown}</strong> of <strong>{total}</strong> {noun}
      </span>
      {chips.map((chip) => (
        <span key={chip.label} className={`list-footer-chip ${chip.tone ? `tone-${chip.tone}` : ""}`}>
          {chip.label} <strong>{chip.value}</strong>
        </span>
      ))}
      <button type="button" className="list-footer-top" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
        ↑ Top
      </button>
    </div>
  );
}
